import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

const ArmenianFlag = () => (
  <svg width="25" height="17" viewBox="0 0 25 17" style={{ display: 'block', borderRadius: 3, border: '1px solid rgba(0,0,0,0.12)' }}>
    <rect width="25" height="5.67" fill="#D90012" />
    <rect y="5.67" width="25" height="5.67" fill="#0033A0" />
    <rect y="11.34" width="25" height="5.67" fill="#F2A800" />
  </svg>
);

const RussianFlag = () => (
  <svg width="25" height="17" viewBox="0 0 25 17" style={{ display: 'block', borderRadius: 3, border: '1px solid rgba(0,0,0,0.15)' }}>
    <rect width="25" height="5.67" fill="#FFFFFF" />
    <rect y="5.67" width="25" height="5.67" fill="#0039A6" />
    <rect y="11.34" width="25" height="5.67" fill="#D52B1E" />
  </svg>
);

const BritishFlag = () => (
  <svg width="25" height="17" viewBox="0 0 60 40" style={{ display: 'block', borderRadius: 3, border: '1px solid rgba(0,0,0,0.15)' }}>
    <clipPath id="uk-flag-clip">
      <rect width="60" height="40" />
    </clipPath>
    <g clipPath="url(#uk-flag-clip)">
      <rect width="60" height="40" fill="#012169" />
      <path d="M0,0 L60,40 M60,0 L0,40" stroke="#fff" strokeWidth="8" />
      <path d="M0,0 L60,40" stroke="#C8102E" strokeWidth="4" />
      <path d="M60,0 L0,40" stroke="#C8102E" strokeWidth="4" />
      <path d="M30,0 v40 M0,20 h60" stroke="#fff" strokeWidth="12" />
      <path d="M30,0 v40 M0,20 h60" stroke="#C8102E" strokeWidth="7" />
    </g>
  </svg>
);

const languages = [
  { code: 'hy', name: 'Հայերեն', Flag: ArmenianFlag },
  { code: 'en', name: 'English', Flag: BritishFlag },
  { code: 'ru', name: 'Русский', Flag: RussianFlag }
];

const LanguageSwitcher = ({ style = {}, className = '' }) => {
  const { i18n } = useTranslation();
  let history, location;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    history = useHistory();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    location = useLocation();
  } catch (e) {
    // Graceful fallback if rendered outside Router context
  }

  const currentLang = (i18n.language || 'hy').slice(0, 2);

  const handleLanguageChange = (code) => {
    i18n.changeLanguage(code);
    if (typeof window !== 'undefined') {
      try {
        localStorage.setItem('i18nextLng', code);
      } catch (e) {}
    }

    // Sync URL path if history and location are available for SEO friendly URLs
    if (history && location) {
      const currentPath = location.pathname;
      // Strip existing language prefix if any
      let cleanPath = currentPath.replace(/^\/(en|ru|hy)(\/|$)/, '/');
      if (!cleanPath.startsWith('/')) {
        cleanPath = '/' + cleanPath;
      }

      let newPath;
      if (code === 'hy') {
        newPath = cleanPath; // Armenian is default root URL
      } else {
        newPath = cleanPath === '/' ? `/${code}` : `/${code}${cleanPath}`;
      }

      if (newPath !== currentPath) {
        history.push(newPath + location.search + location.hash);
      }
    }
  };

  return (
    <div
      className={`language-switcher ${className}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        padding: '6px 0',
        ...style
      }}
      aria-label="Language selection"
    >
      {languages.map(({ code, name, Flag }) => {
        const isActive = currentLang === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => handleLanguageChange(code)}
            title={name}
            aria-label={name}
            style={{
              background: 'none',
              border: 'none',
              padding: '2px',
              margin: 0,
              cursor: 'pointer',
              display: 'inline-flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              outline: 'none',
              opacity: isActive ? 1 : 0.55,
              transform: isActive ? 'scale(1.05)' : 'scale(1)',
              transition: 'opacity 0.2s ease, transform 0.2s ease'
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.currentTarget.style.opacity = '0.9';
                e.currentTarget.style.transform = 'scale(1.05)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.currentTarget.style.opacity = '0.55';
                e.currentTarget.style.transform = 'scale(1)';
              }
            }}
          >
            <Flag />
            <span
              style={{
                display: 'block',
                width: '5px',
                height: '5px',
                borderRadius: '50%',
                backgroundColor: '#00AFEF',
                marginTop: '4px',
                opacity: isActive ? 1 : 0,
                transition: 'opacity 0.2s ease'
              }}
            />
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
